export default "/_next/static/images/team-life-bg@2x-b2b1b7caf5927350d42ae830b12316e8.webp";